import ArtVsArtist from '../components/gallery/ArtVsArtist'

export default [
  {
    id: 100,
    name: 'NO',
    path: '/',
    component: <ArtVsArtist />,
  },
  {
    id: 101,
    name: 'IR',
    path: '/art-vs-artist',
    component: <ArtVsArtist />,
  },
]
